module.exports = __webpack_public_path__ + "static/img/2028.c651da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2028.jpg
// module id = 318
// module chunks = 0